module.exports = __webpack_public_path__ + "static/media/video-yardnapha-issue.09b59d81.png";